<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>Note dello specialista</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onClose()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid class="ion-margin">
    <ion-row>
      <ion-col>
        <ion-card-content>
          <div class="notes-display">
            <ng-container *ngIf="notes && notes.trim().length > 0; else noNotes">
              <div [innerHTML]="notes | safeHtml" class="notes-html"></div>
            </ng-container>
            <ng-template #noNotes>
              <p class="no-notes-placeholder">
                Nessuna nota inserita.
              </p>
            </ng-template>
          </div>
        </ion-card-content>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="danger" (click)="onClose()">Chiudi</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>